import React from 'react';

import COLORS from '@mlb/react-patterns/style/universal.color';
import Headshot from '@mlb/react-patterns/components/Headshot/headshot.tsx';
import TeamLogo from '@mlb/react-patterns/components/TeamLogo/teamLogo.tsx';
import Button from '@mlb/react-patterns/components/Button/button.tsx';

import {
    SUGGESTION_LABELS,
    SUGGESTION_TYPES,
} from 'bdvp-common/src/utils/typeaheadConstants';

import {
    ListItemTextContainer,
    ListItemTeamAttrContainer,
    Link,
    PlaceholderContainer,
} from './TypeaheadBase.styles';

export const formatTypeaheadSuggestions = ({
    suggestions = [],
    shouldShowLabels,
    baseImageProps,
}) => {

    const temp = [];
    const players = {};
    const teams = {};
    const tags = {};
    const dummy = { data: [] };

    if(shouldShowLabels) {

        players['label'] = SUGGESTION_LABELS.players;
        teams['label'] = SUGGESTION_LABELS.teams;
        tags['label'] = SUGGESTION_LABELS.tags;

    }

    players['data'] = [];
    teams['data'] = [];
    tags['data'] = [];

    const imageProps = {
        border: `solid 1px ${COLORS.mlbGrey5}`,
        rounded: true,
        width: '35px',
        height: '35px',
        ...baseImageProps,
    };

    suggestions.forEach((suggestion) => {

        const {
            name,
            teamAbbreviation,
            type,
            id,
            content,
        } = suggestion;

        const isActualResults = Object.values(SUGGESTION_TYPES).includes(type);

        if (!isActualResults) {

            const component = (
                <PlaceholderContainer>
                    {content}
                </PlaceholderContainer>
            );

            dummy.data.push({
                component,
                text: '',
            });

        } else {

            const isTeam = (isActualResults && type === SUGGESTION_TYPES.teams);
            const isTag = (isActualResults && type === SUGGESTION_TYPES.tags);

            const imageType = (isTeam
                ? <TeamLogo
                    {...imageProps}
                    teamId={id}

                />
                : <Headshot
                    {...imageProps}
                    playerId={id}
                    backgroundColor={COLORS.mlbGrey5}
                    fixAspect
                />
            );

            const component = isTag
                ? (
                    <Button
                        ariaLabel={name}
                        shape={'hollow'}
                        size={'sm'}
                        styleName={'default'}
                    >
                        {name}
                    </Button>
                )
                : (
                    <Link ariaLabel={name}>
                        {imageType}
                        <ListItemTextContainer>
                            <span>{name}</span>
                            {teamAbbreviation && <ListItemTeamAttrContainer>{teamAbbreviation}</ListItemTeamAttrContainer>}
                        </ListItemTextContainer>
                    </Link>
                );

            if (isTag) {

                tags.data.push({
                    component,
                    text: name,
                    className: 'tag_item',
                });

            } else {

                (isTeam ? teams.data : players.data).push({
                    component,
                    text: name,
                });

            }

        }

    });

    if (teams.data.length > 0) {

        temp.push(teams);

    }

    if (players.data.length > 0) {

        temp.push(players);

    }

    if (tags.data.length > 0) {

        temp.push(tags);

    }

    if (dummy.data.length > 0) {

        temp.push(dummy);

    }

    return temp;

};
